
module dg.loading {
    export class DataLoaderService {

        public constructor(
            private $timeout: ng.ITimeoutService,
            private waitInterval: number
        ) {

        }

        public loadingInfo = {
            inProgress: false,
            currentLoadingLevel: 0
        };

        timeoutPromise: ng.IPromise<any>;
        //requestsInProgress = 0;

        public startLoading(loadingLevel) {

            this.loadingInfo.currentLoadingLevel = loadingLevel;

            if (!this.loadingInfo.inProgress) {
                this.loadingInfo.inProgress = true;
                //this.requestsInProgress = 0;
            }

            //if (this.requestsInProgress == 0) {
            //    this.checkForEnding();
            //}
        }

        public endLoading() {
            if (this.loadingInfo.inProgress) {
                this.loadingInfo.inProgress = false;
                this.loadingInfo.currentLoadingLevel = 0;
            }
        }


        //public requestStarted() {
        //    if (this.loadingInfo.inProgress) {
        //        this.requestsInProgress++;
        //    }

        //}

        //public requestEnded() {
        //    if (this.loadingInfo.inProgress) {
        //        this.requestsInProgress--;
        //        if (this.requestsInProgress == 0) {
        //            this.checkForEnding();
        //        }
        //    }
        //}

        //checkForEnding() {
        //    if (this.timeoutPromise) {
        //        this.$timeout.cancel(this.timeoutPromise);
        //    }
        //    this.timeoutPromise = this.$timeout(function () {
        //        if (this.requestsInProgress == 0) {
        //            this.endLoading();
        //        }
        //    }, this.waitInterval);
        //}
    }
    angular.module('dg.loading')
        .service('dataLoaderService', DataLoaderService);
}